import React, { memo } from 'react'

import { buildFounderKeyLink } from '../../../../util/wallet/wallet.helpers'
import { openBlankRedirectPage } from '../../../../util/app/app.helpers'
import foundersKeyImage from '../../assets/qbx-founders-key-lit.jpg'
import CommonNftCard from '../../../../components/nfts/CommonNftCard'

const NftCard = ({ t, name, id }) => {
  const handleClick = () => {
    openBlankRedirectPage(buildFounderKeyLink(id))
  }
  return (
    <CommonNftCard
      actionLabel={t('shop.view-key')}
      image={foundersKeyImage}
      name={name}
      onClick={handleClick}
      skipIcon
    />
  )
}

export default memo(NftCard)
